import atLeastOneNecessary from './atLeastOneNecessary'
import verifyUnnecessaryScopes from './verifyUnnecessaryScopes'

export default { atLeastOneNecessary, verifyUnnecessaryScopes }
